import { CheckLine } from '@archipro-design/icons';
import { Button } from '@rocco/components/button';
import { Dialog, DialogContent } from '@rocco/components/dialog';
import { useState, useEffect } from 'react';

export const QuoteAcceptedDialog = ({
    isOpen,
    closeDialog,
}: {
    isOpen: boolean;
    closeDialog: () => void;
}) => {
    const [countdown, setCountdown] = useState(0);

    // Call setCountdown(5) when isOpen changes from false to true
    useEffect(() => {
        if (isOpen) {
            setCountdown(5);
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            const interval = setInterval(() => {
                if (countdown === 0) {
                    closeDialog();
                } else if (countdown > 0) {
                    setCountdown((prev) => prev - 1);
                }
            }, 1000);

            return () => clearInterval(interval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countdown, isOpen]);

    return (
        <Dialog
            open={isOpen}
            onOpenChange={(open) => {
                if (!open) {
                    closeDialog();
                }
            }}
        >
            <DialogContent className="h-160 w-140" closeButton={false}>
                <div className="flex h-full flex-col justify-between">
                    <div></div>
                    <div className="flex flex-col items-center gap-4 self-center">
                        <CheckLine className="h-20 w-20" />
                        <span className="text-2xl font-medium text-[#141414]">
                            Quote accepted
                        </span>
                        <span className="w-100 text-center text-[1.13rem] text-[#141414]">
                            You&apos;ve accepted the quote. You will receive an
                            invoice shortly. Thank you for choosing ArchiPro.
                        </span>

                        <Button
                            color="dark"
                            className="mt-4 h-12 w-30"
                            onClick={closeDialog}
                        >
                            <span className="font-medium text-white">
                                Close
                            </span>
                        </Button>
                    </div>
                    <span className="text-center text-[1.13rem] text-[#141414]/50">
                        Closing in {countdown} seconds
                    </span>
                </div>
            </DialogContent>
        </Dialog>
    );
};
